var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"erro-404"},[_c('div',{staticClass:"error-cot"},[_c('img',{attrs:{"src":require("../assets/img/error_404.png"),"alt":""}}),_c('p',[_vm._v("sorry，找不到你想要的界面")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("闽ICP备14019793号-8")])])])
}]

export { render, staticRenderFns }